import React from "react";
import { Helmet } from "react-helmet";
import { BRAND_NAME } from "../../../_common/content.js";

const HtmlInit: React.FC = () => {
    return (
        <Helmet>
            <meta charSet="utf-8" />
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1, shrink-to-fit=no"
            />
            <meta name="google" content="notranslate" />
            <link rel="shortcut icon" href="/favicon.ico" />
            <link rel="icon" href="/favicon.svg" type="image/svg+xml" />
            <link
                rel="icon"
                href="/favicon.png"
                sizes="512x512"
                type="image/png"
            />
            <link
                rel="icon"
                href="/icon-180.png"
                sizes="180x180"
                type="image/png"
            />
            <link
                rel="icon"
                href="/favicon-96x96.png"
                sizes="96x96"
                type="image/png"
            />
            <link rel="manifest" href="/manifest.json" />
            <meta name="theme-color" content="#000019" />

            <title>{BRAND_NAME}</title>
        </Helmet>
    );
};

export default HtmlInit;
